// 0026: A single gallery tile (large image + title), shared by parent-category and
// item-group grids. Accessible: big tap target, role=button, keyboard activatable,
// alt text on the image. Visual look mirrors the home category card.
import "../../../styles/components/categories/gallery/categoryGalleryTile.scss";

export const CategoryGalleryTile = ({ name, imageUrl, onClick }) => {
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick?.();
    }
  };

  // 0027: two internal layouts at the same total height.
  // - image present  → photo (object-fit cover) + caption bar (unchanged from 0026).
  // - image missing  → Option A "name-as-hero": the NAME large & centered over a soft
  //   brand gradient (with a faint decorative watermark). NO caption bar here, so the
  //   name is shown exactly once.
  const hasImage = Boolean(imageUrl);

  return (
    <div className={`categoryGalleryTile${hasImage ? "" : " isFallback"}`} role="button" tabIndex={0} onClick={onClick} onKeyDown={handleKeyDown} aria-label={name} title={name}>
      {hasImage ? (
        <>
          <div className="tileImageContainer">
            <img src={imageUrl} alt={name} loading="lazy" />
          </div>
          <div className="tileTitleContainer">
            <h3>{name}</h3>
          </div>
        </>
      ) : (
        <div className="tileFallback">
          <i className="fa-solid fa-image tileFallbackGlyph" aria-hidden="true" />
          <span className="tileFallbackName">{name}</span>
        </div>
      )}
    </div>
  );
};

export default CategoryGalleryTile;
